import FormContainer, { PasswordType } from '../formContainer/FormContainer'
import PropTypes from 'prop-types'
import passwordUtils from '../../../utils/inputTextPasswordUtils'
import ChangePasswordErrorMessages from '../../data/ChangePasswordErrorMessages.json'
import { regExSpecial, regExLetter, regExNumber } from '../../../utils/regExpressionsUtils'
import { useState,useEffect } from 'react'
import { passwordErrorMsg, passwordMaingMsg, passwordMsgLength, passwordMsgLetter, 
    passwordMsgNumber, passwordMsgSpecial, passwordCriteriaCompleted } from '../constants/Validations'

export default function PasswordSection( props ) {
    const styleChecked = 'c-password-checklist__list--checked'
    const styleUnchecked = 'c-password-checklist__list--unchecked'
    const styleError = 'c-password-checklist__list--error'

    const [ pswSpecial, setPswSpecial ]= useState( styleUnchecked )
    const [ pswNumber, setPswNumber ]= useState( styleUnchecked )
    const [ pswLetter, setPswLetter ]= useState( styleUnchecked )
    const [ pswLength, setPswLength ] = useState( styleUnchecked )
    const [ pswError, setPswError ] = useState( null )
    const [ pswConfError, setPswConfError ] = useState( null )
    const [ messageNewPassword, setMessageNewPassword  ] = useState( null )
    const [ messageReEnterPassword,setMessageReEnterPassword ] = useState( null )
    const [ dynamicADAMsg, setdynamicADAMsg ] = useState( passwordMaingMsg + passwordMsgLength + passwordMsgLetter + passwordMsgNumber + passwordMsgSpecial )

    const mailWebIdMatches = ( currentPassword ) => {
        let currentEmailVal = false
        let existEmailVal = false
        let webIdVal = false

        const currentEmail = ( props.email && props.email != '' ) ? props.email.substring( 0, props.email.lastIndexOf( '@' ) ) : ''
        currentEmailVal = currentEmail != '' && currentPassword?.toUpperCase().includes( currentEmail.toUpperCase() )

        const existEmail =  ( props.currentEmail && props.currentEmail != '' ) ? props.currentEmail.substring( 0, props.currentEmail.lastIndexOf( '@' ) ) : '' 
        existEmailVal = existEmail != '' && currentPassword?.toUpperCase().includes( existEmail.toUpperCase() ) 
        
        webIdVal = props.webId != '' && currentPassword?.toUpperCase().includes( props.webId?.toUpperCase() )

        if( currentEmailVal || existEmailVal || webIdVal ) 
        {
            setMessageNewPassword( ChangePasswordErrorMessages.MsgUserIdMatch )
            props.setPasswordIsValid( false )
        }
        else
        {
            setMessageReEnterPassword( null )
            setMessageNewPassword( null )
            setPswConfError( null )
            setPswError( null )
        }
    }

    const setUpDinamycADAMsg = () => {
        let dynamicMsg = ''
        if( pswLength === styleError || pswLength === styleUnchecked )
            dynamicMsg += passwordMsgLength
        if( pswLetter === styleError || pswLetter === styleUnchecked )
            dynamicMsg += passwordMsgLetter            
        if( pswNumber === styleError || pswNumber === styleUnchecked )
            dynamicMsg += passwordMsgNumber
        if( pswSpecial === styleError || pswSpecial === styleUnchecked )
            dynamicMsg += passwordMsgSpecial

        if( dynamicMsg.length !== 0 )
        {
            setdynamicADAMsg( passwordMaingMsg + dynamicMsg )
        }
        else
        {
            setdynamicADAMsg( passwordCriteriaCompleted )
        }
    }
    
    const handleCSSStyles = () => {
        if( props.passwordValue !== '' || props.passwordConfirmationValue !== '' ){
                pswLength === styleUnchecked ? setPswLength( styleError ) : setPswLength( pswLength ) 
                pswNumber === styleUnchecked ? setPswNumber( styleError ) : setPswNumber( pswNumber )
                pswLetter === styleUnchecked ? setPswLetter( styleError ) : setPswLetter( pswLetter )
                pswSpecial === styleUnchecked ? setPswSpecial( styleError ) : setPswSpecial( pswSpecial )
        }else{
                setPswLength( styleUnchecked ) 
                setPswNumber( styleUnchecked ) 
                setPswLetter( styleUnchecked ) 
                setPswSpecial( styleUnchecked ) 
                setMessageReEnterPassword( null )
                setMessageNewPassword( null )
                setPswConfError( null )
                setPswError( null )
        }
    }
    
    useEffect( () => {
        if( !props.passwordValue ){
            handleCSSStyles()
        }
        setUpDinamycADAMsg()
        }, [ props.passwordValue ]
    )

    useEffect( () => {
        mailWebIdMatches( props.passwordValue )
        }, [ props.currentEmail, props.email ]
    )

    const handleValidationsForNewPassword = ( currentPassword ) => {
        const maxPasswordLength = 8
        let msgNewPassword = null

        setPswError( null )
        setMessageNewPassword( null )
        
        if( currentPassword.length === 0 ){
            setPswLetter( styleUnchecked )
            setPswSpecial( styleUnchecked )
            setPswLetter( styleUnchecked )
            setPswNumber( styleUnchecked )
            setPswLength( styleUnchecked )
        }
        
        if( currentPassword === props.passwordConfirmationValue ){
            setPswConfError( null )
        }

        if( currentPassword !== '' || props.passwordConfirmationValue !== '' ){
            if( currentPassword?.length >= maxPasswordLength ){
                setPswLength( styleChecked )
            }else{
                setPswLength( styleUnchecked ) 
                msgNewPassword = passwordErrorMsg
            }

            if( regExSpecial.test( currentPassword ) ){
                setPswSpecial( styleChecked ) 
            }else{
                setPswSpecial( styleUnchecked )
                msgNewPassword = passwordErrorMsg
            }

            if( regExLetter.test( currentPassword ) ){
                setPswLetter( styleChecked )
            }else{
                setPswLetter( styleUnchecked )
                msgNewPassword = passwordErrorMsg
            }

            if( regExNumber.test( currentPassword ) ){
                setPswNumber( styleChecked ) 
            }else{
                setPswNumber( styleUnchecked )
                msgNewPassword = passwordErrorMsg
            }
            
            if( !msgNewPassword )
            {
                mailWebIdMatches( currentPassword )
                if( props.passwordConfirmationValue === currentPassword )
                {
                    setMessageReEnterPassword( null )
                    setMessageNewPassword( null )
                    setPswConfError( null )
                    setPswError( null )
                    if ( props.passwordConfirmationValue )
                    {
                        props.setPasswordIsValid( true )
                        props.setPasswordValue( currentPassword ) 
                    }
                }
                else
                {
                    if ( props.passwordConfirmationValue )
                    {
                        setPswConfError( null )
                        props.setPasswordIsValid( false )
                    }
                }
            }else{
                if( props.passwordConfirmationValue && currentPassword && props.passwordConfirmationValue !== currentPassword ){
                    setPswConfError( ChangePasswordErrorMessages.MsgPasswordNoMatch )
                    props.setPasswordIsValid( false )
                }
                setMessageNewPassword( msgNewPassword )
                props.setPasswordIsValid( false )
            } 
        }
    }

    const handleValidationsForReEnterPassword = ( currentPasswordConfirmation ) => {
        setMessageReEnterPassword( null )
        setPswConfError( null )
        if( currentPasswordConfirmation && props.passwordValue ){
            if ( currentPasswordConfirmation === props.passwordValue ){
                setMessageReEnterPassword( null )
                if( !pswError ){
                    props.setPasswordIsValid( true )
                    props.setPasswordConfirmationValue( currentPasswordConfirmation ) 
                }
            }else{
                setMessageReEnterPassword( ChangePasswordErrorMessages.MsgPasswordNoMatch )
                props.setPasswordIsValid( false )
            }
        }
    }
    
    const handlePassword = ( event ) => { 
        props.setPasswordValue( event.target.value )  
        handleValidationsForNewPassword( event.target.value )
        passwordUtils.eyeColorValidation( 'password' , event.target.value ) 
    }

    const handlePasswordConfirmation = ( event ) => {
        props.setPasswordConfirmationValue( event.target.value ) 
        handleValidationsForReEnterPassword( event.target.value )       
        passwordUtils.eyeColorValidation( 'passwordConfirmation' , event.target.value )
    }

    const handlePasswordBlur = ( ) => {
        if( messageNewPassword ){
            setPswError( messageNewPassword )
            props.setPasswordIsValid( false )
        }
        else
        {        
            if( props.passwordConfirmationValue && props.passwordValue && props.passwordConfirmationValue !== props.passwordValue ){
                setPswConfError( ChangePasswordErrorMessages.MsgPasswordNoMatch )
                props.setPasswordIsValid( false )
            }
            else{
                if ( pswError && pswConfError ) {
                    props.setPasswordIsValid( false )
                }
            }
        }

        if ( props.passwordValue?.length === 0 && props.passwordConfirmationValue?.length === 0 ) {
            props.setPasswordIsValid( true )
        }
        handleCSSStyles()
    }

    const handlePasswordConfirmationBlur = ( ) => {
        if( messageReEnterPassword ){
            setPswConfError( messageReEnterPassword )
        }
        else
        {
            if( props.passwordValue && props.passwordConfirmationValue !== props.passwordValue ){
                setPswConfError( ChangePasswordErrorMessages.MsgPasswordNoMatch )
                props.setPasswordIsValid( false )
            }
            else{
                if ( !pswError && pswConfError ) {
                    props.setPasswordIsValid( true )
                }
            }
        }
        handleCSSStyles()
    }

    const { displayBox, displayTitle, displayNotificacionBottom, pswAriaLabel, formInputsClass, pswConfariaLabel } = props
    return (
        <FormContainer 
            formTitle = { displayTitle === true ? 'Password' : '' }
            formTitleAdaMsg = { displayTitle === true ? 'Password section' : ''  }
            formTitleClassName = 'c-form-intro c-form-intro--long'
            containerClassName = { displayBox === true ? 'c-form-container c-form-container--box mb-5' : '' }
            formInputsClass = { formInputsClass }
            formInputComponents = { [ 
                { 
                    ...props.passwordConfig,
                    onCopy: ( e ) => { e.preventDefault(); return false },
                    onChange: ( e ) => handlePassword( e ),
                    onBlur: () =>  handlePasswordBlur(),
                    value: props.passwordValue,
                    invalidText: pswError,
                    invalid: pswError ? true : false,
                    labelText: 'New Password',
                    id: 'password',
                    type: 'password',
                    maxLength: 79,
                    tabIndex: 0,
                    ariaLabel: pswAriaLabel + dynamicADAMsg,
                    visible: true,
                    inputType: PasswordType,
                    autoComplete: 'new-password'
                },
                { 
                    ...props.passwordConfirmationConfig,
                    onCopy: ( e ) => { e.preventDefault(); return false },
                    onChange: ( e ) => handlePasswordConfirmation( e ),
                    onFocus: () => handleCSSStyles(),
                    onBlur: () =>  handlePasswordConfirmationBlur(),
                    value: props.passwordConfirmationValue,          
                    invalidText: pswConfError,
                    invalid: pswConfError ? true : false,
                    labelText: 'Re-enter New Password',
                    id: 'passwordConfirmation',
                    type: 'password',
                    maxLength: 79,
                    tabIndex: 0,
                    ariaLabel: pswConfariaLabel,
                    visible: true,
                    inputType: PasswordType,
                    autoComplete: 'new-password'
                } 
            ] }
            notificationVisible = { true }
            notificationType = { PasswordType }
            showInputComponentsInColum = { true }
            notification = {
                {     
                    ...props.notification,
                    pswSpecial: pswSpecial,
                    pswNumber: pswNumber,
                    pswLength: pswLength,
                    pswLetter: pswLetter,
                    dynamicADAMsg: dynamicADAMsg
                }
            }
            displayNotificacionBottom = { displayNotificacionBottom } 
        >
        </FormContainer>
    )
}

PasswordSection.propTypes = {
    passwordConfig: PropTypes.instanceOf( Object ),
    passwordConfirmationConfig: PropTypes.instanceOf( Object ),
    email: PropTypes.string,
    currentEmail: PropTypes.string,
    webId: PropTypes.string,
    setPasswordIsValid: PropTypes.func.isRequired,
    displayBox: PropTypes.bool.isRequired,
    displayTitle: PropTypes.bool.isRequired,
    displayNotificacionBottom: PropTypes.bool.isRequired,
    showInputComponentsInColum: PropTypes.bool.isRequired,
    formInputsClass: PropTypes.string.isRequired,
    passwordValue: PropTypes.string,
    passwordConfirmationValue: PropTypes.string,
    setPasswordValue: PropTypes.func.isRequired,
    setPasswordConfirmationValue: PropTypes.func.isRequired,
    notification: PropTypes.shape( {
        contentWrapper: PropTypes.string,
        visible: PropTypes.bool.isRequired,
    } ),
    pswAriaLabel: PropTypes.string.isRequired,
    pswConfariaLabel: PropTypes.string.isRequired
}